var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18954",
    "data-name": "Path 18954",
    d: "M14.276,192.8H1.724A1.726,1.726,0,0,0,0,194.524v6.527a1.726,1.726,0,0,0,1.724,1.724H14.276A1.726,1.726,0,0,0,16,201.051v-6.527a1.726,1.726,0,0,0-1.724-1.724Z",
    transform: "translate(0 -186.775)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18955",
    "data-name": "Path 18955",
    d: "M14.276,3.012H9.255a1.4,1.4,0,0,1-1.207-.87l-.21-.631A2.328,2.328,0,0,0,5.741,0H1.724A1.726,1.726,0,0,0,0,1.724v4a2.649,2.649,0,0,1,1.724-.636H14.276A2.649,2.649,0,0,1,16,5.724V4.736a1.726,1.726,0,0,0-1.724-1.724Z",
    fill: "#adafb3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.4eaab2c27ca4d63c0c1a02c0fe60409f.svg";
export { ForwardRef as ReactComponent };